// Environment-dependent config (API base URL, social-auth ids, the camera
// stream URL) used to be a build-time static import of `config/local.json` -
// baked in at `yarn build`, identical for every deployed environment (see
// findings I-9). It's now fetched at app boot from `/config.json`, a static
// file served alongside the built app: `public/config.json` (committed, used
// as-is for local dev) is regenerated in place from the container's real env
// vars before the server starts in every deployed environment - see
// grwr-docker-config's `build/front/templates/generate-runtime-config.js`.
//
// `main.js` awaits `loadRuntimeConfig()` before mounting the app, so anything
// that runs after mount (route guards, `server/request.js`, component
// `mounted()` hooks) can safely call `getRuntimeConfig()` synchronously.
let config = null

export function loadRuntimeConfig () {
  return fetch('/config.json', { cache: 'no-store' })
    .then(response => response.json())
    .then(data => {
      config = data
      return config
    })
}

export function getRuntimeConfig () {
  if (!config) {
    throw new Error('Runtime config was not loaded yet - call loadRuntimeConfig() before getRuntimeConfig()')
  }
  return config
}
